import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { services, formComponents } from "../utils/Formconfig.js";
import { validationRules, handleValidation } from "../utils/validation.js";
import Stepper from "../components/Stepper.jsx";
import "../styles/appointment.css";
import confetti from "canvas-confetti"; // 🎉 Import confetti
import emailjs from '@emailjs/browser';



export default function Appointment() {
    const [selectedServices, setSelectedServices] = useState([]);
    const [queuedForms, setQueuedForms] = useState([]);
    const [currentForm, setCurrentForm] = useState(null);
    const [showForm, setShowForm] = useState(false);
    const [completed, setCompleted] = useState(false);
    const [currentStep, setCurrentStep] = useState(1);
    const [errors, setErrors] = useState({});
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const dropdownRef = useRef(null);
    const [completedForms, setCompletedForms] = useState([]);
    const [formData, setFormData] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const [changeDropDownError, setChangeDropDownError] = useState(true);
    const [animatingService, setAnimatingService] = useState(null);
    const navigate = useNavigate();
    

    // ...existing code...
const sendEmail = (formData) => {
    emailjs.send(
  'service_bgojf2l',
  'template_3kzae4d',
  formData, // ✅ This sends actual data
  'uEDMNiFM4kug9lSPY'
)
    .then((result) => {
        console.log('Email sent:', result.text);
    }, (error) => {
        console.error('Email send error:', error);
    });
};
// ...existing code...
    useEffect(() => {
        setTimeout(() => {
            setIsLoading(false);
        }, 1000);
    }, []);

    const handleInputChange = (event) => {
    const { name, type, checked, value } = event.target;

    // Validate input and get error message
        const errorMessage = handleValidation(name, value);

        console.log(`Input Change - ${name}: ${value}, Error: ${errorMessage}`); // Debugging log      

    setFormData((prev) => ({
        ...prev,
        [name]: type === "checkbox" ? checked : value,
    }));

        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: errorMessage, // Update errors state
        }));

    };
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsDropdownOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);


    const validateInput = (name, value) => {
        const rule = validationRules[name] ;
        if (!rule) return null;

        if (rule.required && !value) {
            return `${name.replace(" ", "").replace("_", " ")} is required.`;
        }

        if (rule.pattern && !rule.pattern.test(value)) {
            return rule.message;
        }

        if (rule.minLength && value.length < rule.minLength) {
            return `Address must be at least ${rule.minLength} characters.`;
        }

        if (rule.maxLength && value.length > rule.maxLength) {
            return rule.maxLengthMessage || `Maximum length is ${rule.maxLength + 1} characters.`;
        }
        
        return null;
    };

    const handleCheckboxChange = (event) => {
        const { value } = event.target;

        if (selectedServices.includes(value)) {
            // If service is already selected, remove it
            handleRemoveService(value);
        } else {
            // If service is not selected, add it immediately and animate
            setSelectedServices((prev) => [...prev, value]);
            setAnimatingService(value); // Start animation

            // Only remove the animation effect after duration
            setTimeout(() => {
                setAnimatingService(null);
            }, 500);
        }
    };

    const handleDropdownToggle = () => {
        setIsDropdownOpen((prev) => !prev);
    };

    const handleRemoveService = (serviceValue) => {
        setSelectedServices((prev) => prev.filter((value) => value !== serviceValue));
    };

    const handleNextButtonClick = () => {
        const formErrors = {};
        const formInputs = document.querySelectorAll("input[required], select[required]");

        // Validate required fields
        formInputs.forEach((input) => {
            const { name, value, required } = input;
            if (required && !value.trim()) {
                formErrors[name] = `${name.replace(/_/g, " ")} is required.`;
            } else if (validationRules[name]) {
                const error = validateInput(name, value);
                if (error) {
                    formErrors[name] = error;
                }
            }
        });

        // Validate dropdown selection
        if (!selectedServices.length) {
            formErrors.selectedServices = "Please select at least one service.";
        }

        setErrors(formErrors);

        // STOP if errors exist
        if (Object.keys(formErrors).length > 0) {
            const firstErrorElement = document.querySelector(".error-field, .dropdown-error");
            if (firstErrorElement) {
                firstErrorElement.scrollIntoView({ behavior: "smooth" });
            }
            return; // Stop further execution
        }

        // Proceed if no errors
        setChangeDropDownError(false);

        const formsQueue = selectedServices.reduce((acc, service) => {
            const serviceData = services.find((s) => s.value === service);
            if (serviceData) {
                acc.push(...serviceData.forms);
            }
            return acc;
        }, []);

        const uniqueFormsQueue = Array.from(new Set(formsQueue));
        setQueuedForms(uniqueFormsQueue);
        setCurrentForm(uniqueFormsQueue[0] || null);
        setShowForm(uniqueFormsQueue.length > 0);
        setCurrentStep(1);
    };


    const handleNextForm = (e) => {
        e.preventDefault();
        const formErrors = {};

        // Validate all required inputs and selects
        const formInputs = document.querySelectorAll("input[required], select[required]");
        formInputs.forEach((input) => {
            const { name, value } = input;
            const validationError = handleValidation(name, value);

            if (validationError) {
                formErrors[name] = validationError;
            }
        });

        // Validate all required radio button groups
        const radioGroups = new Set();
        document.querySelectorAll("input[type='radio'][required]").forEach((radio) => {
            radioGroups.add(radio.name);
        });

        radioGroups.forEach((groupName) => {
            const selectedValue = document.querySelector(`input[name="${groupName}"]:checked`);
            if (!selectedValue) {
                formErrors[groupName] = "Please select an option.";
            }
        });

        // If errors exist, prevent form submission
        if (Object.keys(formErrors).length > 0) {
            setErrors(formErrors);

            // Highlight empty fields by adding a CSS class
            Object.keys(formErrors).forEach((field) => {
                const input = document.querySelector(`[name="${field}"]`);
                if (input) {
                    input.classList.add("error-field"); // Add a red border or highlight
                }
            });

            return;
        }

        // If no errors, proceed to the next form
        if (queuedForms.length > 0) {
            const nextForm = queuedForms[0];
            setCompletedForms((prev) => [...prev, nextForm]);
            const updatedQueue = queuedForms.slice(1);

            setQueuedForms(updatedQueue);
            setCurrentForm(updatedQueue[0] || null);
            setCurrentStep((prevStep) => prevStep + 1);

        } else {
            setShowForm(false);
            setCompleted(true);
            setCurrentStep(0);
                sendEmail(formData); // <-- This sends the email!

        }
    };



    const handleBackForm = () => {
        if (currentStep === 1) {
            setShowForm(false);
        } else if (completedForms.length > 0) {
            const previousForm = completedForms[completedForms.length - 1];
            setQueuedForms((prev) => [previousForm, ...prev]);
            setCompletedForms((prev) => prev.slice(0, -1));
            setCurrentForm(previousForm);
            setCurrentStep((prevStep) => prevStep - 1);
        }
        if (currentStep > 1) setCurrentStep(currentStep - 1);
    };

    const handleImageClick = () => {
        if (!showForm) {
            navigate("/");
        }
    };

    const totalSteps = completedForms.length + queuedForms.length;
    const CurrentFormComponent = formComponents[currentForm];


    const triggerConfetti = () => {
        var duration = 2 * 1000; // 2 seconds
        var end = Date.now() + duration;

        (function frame() {
            confetti({
                particleCount: 7,
                angle: 60,
                spread: 55,
                origin: { x: 0 },
                colors: ["#FF5733", "#FFC300", "#DAF7A6", "#C70039", "#581845"]
            });

            confetti({
                particleCount: 7,
                angle: 120,
                spread: 55,
                origin: { x: 1 },
                colors: ["#FF5733", "#FFC300", "#DAF7A6", "#C70039", "#581845"]
            });

            if (Date.now() < end) {
                requestAnimationFrame(frame);
            }
        })();
    };                          

    

    




    return (
    <>
        <div>
            {isLoading && (
                <div className="loader-wrap">
                    <div className="preloader">
                        <div className="preloader-close">close</div>
                        <div id="handle-preloader" className="handle-preloader">
                            <div className="animation-preloader">
                                <div className="txt-loading">
                                    <img src="assets/images/animation_logo.gif" alt="img" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {!completed ? (
                <section className="appointment-area">
                    <div className="auto-container">
                            <div
                                className="appointment_logo"
                                onClick={handleImageClick}
                                style={{ cursor: "pointer" }}
                            >
                            <img
                                src="/assets/images/R_logo3.png"
                                alt="img"
                                style={{
                                    width: "100px",
                                    height: "auto",
                                    transition: "transform 0.3s ease-in-out"
                                }}
                                onMouseOver={(e) => e.target.style.transform = "scale(1.1)"}
                                onMouseOut={(e) => e.target.style.transform = "scale(1)"}
                                />
                            </div>
                        
                        <div className="appointment-title" style={{ textAlign: "left" }}>
                            <h2>
                                <span>
                                    Just a Few Steps Away! Fill out the online form, and we’ll follow up with you soon.
                                </span>
                            </h2>
                            <p>
                                We’re here to make the process as seamless as possible and ensure all your needs are met.
                                Simply complete the form below, and a member of our team will reach out to you shortly.
                                Thank you for choosing us—we look forward to connecting with you!
                            </p>
                        </div>
                        <div className="row">
                            <div className="col-xl-12">
                                <div className="appointment-form-box">
                                    {!showForm ? (
                                        <form className="appointment-form" onSubmit={(e) => e.preventDefault()} style={{ textAlign: "left" }}>
                                                    <div>
                                                        <h4>Contact Information</h4>
                                                        <div className="row">
                                                            <div className="col-xl-6">
                                                                <div className={`single-box ${errors.First_Name ? "error-field" : ""}`}>
                                                                    <label htmlFor="First_Name">First Name</label>
                                                                    <input
                                                                        id="First_Name"
                                                                        type="text"
                                                                        name="First_Name"
                                                                        value={formData.First_Name || ""}
                                                                        onChange={handleInputChange}
                                                                        maxLength={20}
                                                                        required
                                                                    />
                                                                    {errors.First_Name && <span className="error">{errors.First_Name}</span>}
                                                                </div>
                                                            </div>
                                                            <div className="col-xl-6">
                                                                <div className={`single-box ${errors.Last_Name ? "error-field" : ""}`}>
                                                                    <label htmlFor="Last_Name">Last Name</label>
                                                                    <input
                                                                        id="Last_Name"
                                                                        type="text"
                                                                        name="Last_Name"
                                                                        value={formData.Last_Name || ""}
                                                                        onChange={handleInputChange}
                                                                        maxLength={20}
                                                                        required
                                                                    />
                                                                    {errors.Last_Name && <span className="error">{errors.Last_Name}</span>}
                                                                </div>
                                                            </div>
                                                                <div className="col-xl-12">
                                                                <div className={`single-box ${errors.Address ? "error-field" : ""}`}>
                                                                    <label htmlFor="Address">Address</label>
                                                                    <input
                                                                        id="Address"
                                                                        type="text"
                                                                        name="Address"
                                                                        value={formData.Address || ""}
                                                                        onChange={handleInputChange}
                                                                        
                                                                    />
                                                                    {errors.Address && <span className="error">{errors.Address}</span>}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-xl-4">
                                                                <div className={`single-box ${errors.City ? "error-field" : ""}`}>
                                                                    <label htmlFor="City">City</label>
                                                                    <input
                                                                        id="City"
                                                                        type="text"
                                                                        name="City"
                                                                        value={formData.City || ""}
                                                                        onChange={handleInputChange}
                                                                        maxLength={20}
                                                                    />
                                                                    {errors.City && <span className="error">{errors.City}</span>}
                                                                </div>
                                                            </div>
                                                            <div className="col-xl-4">
                                                                <div className="single-box selectbox">
                                                                    <label htmlFor="State">State</label>
                                                                    <select
                                                                        id="State"
                                                                        name="State"
                                                                        value={formData.State || ""}
                                                                        onChange={(e) => {
                                                                            const error = handleValidation(e.target.name, e.target.value);
                                                                            const input = e.target;
                                                                            const errorMessage = input.nextElementSibling;
                                                                            if (errorMessage) { errorMessage.textContent = error; }
                                                                            input.classList.toggle("invalid", !!error);
                                                                            handleInputChange(e);
                                                                        }}
                                                                        
                                                                    >
                                                                    <option value="">State</option>
                                                                    <option>Alabama</option>
                                                                    <option>Alaska</option>
                                                                    <option>Arizona</option>
                                                                    <option>Arkansas</option>
                                                                    <option>California</option>
                                                                    <option>Colorado</option>
                                                                    <option>Connecticut</option>
                                                                    <option>Delaware</option>
                                                                    <option>Florida</option>
                                                                    <option>Georgia</option>
                                                                    <option>Hawaii</option>
                                                                    <option>Idaho</option>
                                                                    <option>Illinois</option>
                                                                    <option>Indiana</option>
                                                                    <option>Iowa</option>
                                                                    <option>Kansas</option>
                                                                    <option>Kentucky</option>
                                                                    <option>Louisiana</option>
                                                                    <option>Maine</option>
                                                                    <option>Maryland</option>
                                                                    <option>Massachusetts</option>
                                                                    <option>Michigan</option>
                                                                    <option>Minnesota</option>
                                                                    <option>Mississippi</option>
                                                                    <option>Missouri</option>
                                                                    <option>Montana</option>
                                                                    <option>Nebraska</option>
                                                                    <option>Nevada</option>
                                                                    <option>New Hampshire</option>
                                                                    <option>New Jersey</option>
                                                                    <option>New Mexico</option>
                                                                    <option>New York</option>
                                                                    <option>North Carolina</option>
                                                                    <option>North Dakota</option>
                                                                    </select>
                                                                    {errors.State && <span className="error">{errors.State}</span>}
                                                                </div>
                                                            </div>
                                                            <div className="col-xl-4">
                                                                <div className={`single-box ${errors.Zip_Code ? "error-field" : ""}`}>
                                                                    <label htmlFor="Zip_Code">Zip Code</label>
                                                                    <input
                                                                        id="Zip_Code"
                                                                        type="text"
                                                                        name="Zip_Code"
                                                                        value={formData.Zip_Code || ""}
                                                                        onChange={handleInputChange}
                                                                    />
                                                                    {errors.Zip_Code && <span className="error">{errors.Zip_Code}</span>}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-xl-6">
                                                                <div className={`single-box ${errors.Phone_Number ? "error-field" : ""}`}>
                                                                    <label htmlFor="Phone_Number">Phone Number</label>
                                                                    <input
                                                                        id="Phone_Number"
                                                                        type="text"
                                                                        name="Phone_Number"
                                                                        value={formData.Phone_Number || ""}
                                                                        onChange={handleInputChange}
                                                                        maxLength={10} // This prevents more than 10 digits
                                                                        required
                                                                    />
                                                                    {errors.Phone_Number && <span className="error">{errors.Phone_Number}</span>}
                                                                </div>
                                                            </div>
                                                            <div className="col-xl-6">
                                                                <div className={`single-box ${errors.Email_Address ? "error-field" : ""}`}>
                                                                    <label htmlFor="Email_Address">Email Address</label>
                                                                    <input
                                                                        id="Email_Address"
                                                                        type="email"
                                                                        name="Email_Address"
                                                                        value={formData.Email_Address || ""}
                                                                        onChange={handleInputChange}
                                                                        required
                                                                    />
                                                                    {errors.Email_Address && <span className="error">{errors.Email_Address}</span>}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    <div
                                                        ref={dropdownRef}
                                                        style={{ position: "relative", width: "300px" }}
                                                        onMouseEnter={() => setIsDropdownOpen(true)}
                                                        onMouseLeave={() => setIsDropdownOpen(false)}
                                                    >
                                                        {selectedServices.length ? (
                                                            <span style={{
                                                                color: "black",
                                                                fontSize: "18px",
                                                                fontFamily: "Barlow, sans- serif", // Add the desired font family
                                                                fontWeight: 600              // Add the desired font weight
                                                            }}>
                                                                Your Selected Services
                                                            </span>
                                                        ) : (
                                                            <span style={{
                                                                color: changeDropDownError ? "black" : "red",
                                                                fontSize: "18px",
                                                                fontFamily: "Barlow, sans- serif", // Add the desired font family
                                                                fontWeight: 600              // Add the desired font weight
                                                            }}>
                                                                Please select a service
                                                            </span>
                                                        )}

                                                        <span
                                                            onClick={(e) => {
                                                                e.preventDefault(); // Prevent default navigation or form submission
                                                                handleDropdownToggle(); // Toggle the dropdown
                                                            }}
                                                            style={{
                                                                width: Math.max(300, selectedServices.length * 10) + "px", // Dynamic width
                                                                padding: "6px",
                                                                fontFamily: "Barlow, sans- serif",
                                                                fontSize: "16px",
                                                                border:
                                                                    errors.selectedServices && selectedServices.length === 0
                                                                        ? "2px solid red"
                                                                        : "1px solid #ccc",
                                                                borderRadius: "5px",
                                                                backgroundColor: "#f9f9f9",
                                                                textAlign: "left",
                                                                cursor: "pointer",
                                                                display: "flex",
                                                                flexWrap: "wrap",
                                                                gap: "5px",
                                                            }}
                                                        >
                                                            {selectedServices.length > 0 ? (

                                                                selectedServices.map((serviceValue) => {

                                                                    const selectedService = services.find((service) => service.value === serviceValue);

                                                                    return selectedService ? (
                                                                        <span

                                                                            key={serviceValue}

                                                                            className={`service-item ${animatingService === serviceValue ? "morphing" : ""}`}
                                                                        >

                                                                            {selectedService.label}
                                                                            <span

                                                                                onClick={(e) => {

                                                                                    e.preventDefault();

                                                                                    e.stopPropagation();

                                                                                    handleRemoveService(serviceValue);

                                                                                }}

                                                                                className="remove-btn"
                                                                            >

                                                                                ✖
                                                                            </span>
                                                                        </span>

                                                                    ) : null;

                                                                })

                                                            ) : (
                                                                <span>

                                                                    Select Services <span className="dropdown-arrow">▼</span>
                                                                </span>

                                                            )}

                                                        </span>

                                                        {/* Display error message */}
                                                        {/*{errors.selectedServices && (*/}
                                                        {/*    <span className="error dropdown-error">{errors.selectedServices}</span>*/}
                                                        {/*)}*/}
                                                        {isDropdownOpen && (
                                                            <div
                                                                style={{
                                                                    position: "absolute",
                                                                    top: "100%",
                                                                    left: "0",
                                                                    width: "100%",
                                                                    border: "1px solid #ccc",
                                                                    borderRadius: "5px",
                                                                    backgroundColor: "#fff",
                                                                    padding: "10px",
                                                                    maxHeight: "200px",
                                                                    overflowY: "auto",
                                                                    zIndex: 1000,
                                                                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                                                                }}
                                                            >
                                                                {services.map((service) => (
                                                                    <div
                                                                        key={service.value}
                                                                        style={{
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                            padding: "8px",
                                                                            borderBottom: "1px solid #f0f0f0",
                                                                            cursor: "pointer",
                                                                        }}
                                                                        onClick={(e) => { if (e.target.tagName !== "INPUT") { handleCheckboxChange({ target: { value: service.value, checked: !selectedServices.includes(service.value) }, }); } }}
                                                                    >
                                                                        <input
                                                                            type="checkbox"
                                                                            value={service.value}
                                                                            checked={selectedServices.includes(service.value)}
                                                                            onChange={handleCheckboxChange}
                                                                            style={{
                                                                                width: "10px",
                                                                                height: "10px",
                                                                                marginRight: "10px",
                                                                                cursor: "pointer",
                                                                            }}

                                                                        />
                                                                        <label style={{ fontSize: "16px", fontWeight: "400", color: "#212121", cursor: "pointer" }}>
                                                                            {service.label}
                                                                        </label>

                                                                    </div>
                                                                ))}
                                                            </div>
                                                        )}
                                                    </div>
                                                    

                                                

                                                    <div className="single-box" style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
                                                        <button type="button" className="theme-btn btn-style-one" onClick={() => navigate("/")}>
                                                            Home
                                                        </button>
                                                        <button type="button" className="theme-btn btn-style-one" onClick={handleNextButtonClick}>
                                                            Next
                                                        </button>
                                                    </div>
                                            </div>
                                        </form>
                                    ) : (
                                        <div className="form-steps">
                                            <div>
                                                <div className="col-sm-12">
                                                    <Stepper currentStep={currentStep} totalSteps={totalSteps} />
                                                </div>
                                                {currentForm ? (
                                                    <div>
                                                                <div className="form-group">
                                                                    <CurrentFormComponent formData={formData} handleInputChange={handleInputChange} errors={errors} />
                                                        </div>
                                                                <div className="form-navigation">
                                                            {currentStep > 0 && (
                                                                <button
                                                                    type="button"
                                                                    className="theme-btn btn-style-two"
                                                                    onClick={handleBackForm}
                                                                >
                                                                    Back
                                                                </button>
                                                            )}
                                                            {currentStep < totalSteps ? (
                                                                <button
                                                                    type="button"
                                                                    className="theme-btn btn-style-one"
                                                                    onClick={handleNextForm}
                                                                >
                                                                    Next
                                                                </button>
                                                            ) : (
                                                                <button
                                                                    type="button"
                                                                                className="theme-btn btn-style-one"
                                                                                onClick={handleNextForm}
                                                                >
                                                                    Submit
                                                                </button>
                                                            )}
                                                        </div>
                                                    </div>
                                                        ) : (  
                                                                <div className="thank-you-message">
                                                                    {triggerConfetti()}
                                                                    <h2>🎉 Thank You! 🎉</h2>
                                                                    <p>Your submission was successful. We will contact you soon.</p>
                                                                    <button type="button" className="theme-btn btn-style-one" onClick={() => navigate("/")}>
                                                                        Home
                                                                    </button>

                                                                </div>

                                                )}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            ) : (
                <p3>Thank you for submitting the form!</p3>
            )}
        </div>
    </>
);
}
